import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

const Buttons = props => (
  <section className="module-filter top">
    <div className="flex">
      <div className="flex filter-box">
        <h2 id="selectTask" className="container-filter-h2">
          {props.language.summary.filter.selectTask}:{' '}
          {props.filter.selectTask ? props.filter.selectTask : props.language.summary.filter.all}
        </h2>
        <ul className="container-filter-ul">
          <li className="container-filter-li">
            <i className="fas fa-caret-down" />
            <ul onMouseLeave={props.handleChangeReset}>
              <li>
                {' '}
                <input
                  type="text"
                  data-update="selectTask"
                  onChange={props.handleChange}
                  autoComplete="off"
                  value={props.input.selectTask}
                />{' '}
              </li>
              <li
                role="button"
                tabIndex={0}
                data-parent="selectTask"
                onClick={props.handleFilter}
                data-select={'ALL'}
              >
                {props.language.summary.filter.all}
              </li>
              {_.filter(props.datos.tasks, o => {
                return o.value.toUpperCase().indexOf(props.input.selectTask.toUpperCase()) > -1;
              }).map((item, i) => (
                <li
                  key={i}
                  data-select={item.value}
                  data-name={item.value}
                  onClick={props.handleFilter}
                  data-parent="selectTask"
                >
                  {item.label}
                </li>
              ))}
            </ul>
          </li>
        </ul>
      </div>
      <div className="flex filter-box">
        <h2 id="selectDriver" className="container-filter-h2">
          {props.language.summary.filter.selectDriver}:{' '}
          {props.filter.selectDriver
            ? props.filter.selectDriver
            : props.language.summary.filter.all}
        </h2>
        <ul className="container-filter-ul">
          <li className="container-filter-li">
            <i className="fas fa-caret-down" />
            <ul onMouseLeave={props.handleChangeReset}>
              <li>
                {' '}
                <input
                  type="text"
                  data-update="selectDriver"
                  onChange={props.handleChange}
                  autoComplete="off"
                  value={props.input.selectDriver}
                />{' '}
              </li>
              <li
                role="button"
                tabIndex={0}
                data-parent="selectDriver"
                onClick={props.handleFilter}
                data-select={'ALL'}
              >
                {props.language.summary.filter.all}
              </li>

              {_.filter(props.datos.drivers, o => {
                return o.value.toUpperCase().indexOf(props.input.selectDriver.toUpperCase()) > -1;
              }).map((item, i) => (
                <li
                  key={i}
                  data-select={item.value}
                  data-name={item.value}
                  onClick={props.handleFilter}
                  data-parent="selectDriver"
                >
                  {item.label}
                </li>
              ))}
            </ul>
          </li>
        </ul>
      </div>
      <div className="flex filter-box">
        <h2 id="selectVehicle" className="container-filter-h2">
          {props.language.summary.filter.selectVehicle}:{' '}
          {props.filter.selectVehicle
            ? props.filter.selectVehicle
            : props.language.summary.filter.all}
        </h2>
        <ul className="container-filter-ul">
          <li className="container-filter-li">
            <i className="fas fa-caret-down" />
            <ul onMouseLeave={props.handleChangeReset}>
              <li>
                {' '}
                <input
                  type="text"
                  data-update="selectVehicle"
                  onChange={props.handleChange}
                  autoComplete="off"
                  value={props.input.selectVehicle}
                />{' '}
              </li>
              <li
                role="button"
                tabIndex={0}
                data-parent="selectVehicle"
                onClick={props.handleFilter}
                data-select={'ALL'}
              >
                {props.language.summary.filter.all}
              </li>
              {_.filter(props.datos.vehicles, o => {
                return o.value.toUpperCase().indexOf(props.input.selectVehicle.toUpperCase()) > -1;
              }).map((item, i) => (
                <li
                  key={i}
                  data-select={item.value}
                  data-name={item.value}
                  onClick={props.handleFilter}
                  data-parent="selectVehicle"
                >
                  {item.label}
                </li>
              ))}
            </ul>
          </li>
        </ul>
      </div>
      <div className="flex filter-box">
        <h2 id="selectState" className="container-filter-h2">
          {props.language.summary.filter.selectState}:{' '}
          {props.filter.selectState ? props.filter.selectState : props.language.summary.filter.all}
        </h2>
        <ul className="container-filter-ul">
          <li className="container-filter-li">
            <i className="fas fa-caret-down" />
            <ul onMouseLeave={props.handleChangeReset}>
              {/*      <li>
                {' '}
                <input
                  type="text"
                  data-update="selectState"
                  onChange={props.handleChange}
                  autoComplete="off"
                  value={props.input.selectState}
                />{' '}
              </li> */}
              <li
                role="button"
                tabIndex={0}
                data-parent="selectState"
                onClick={props.handleFilter}
                data-select={'ALL'}
              >
                {props.language.summary.filter.all}
              </li>
              {_.filter(props.datos.state, o => {
                return o.indexOf(props.input.selectState.toUpperCase()) > -1;
              }).map((item, i) => (
                <li
                  key={i}
                  data-select={item}
                  data-name={item}
                  onClick={props.handleFilter}
                  data-parent="selectState"
                >
                  {props.language.summary.nfa[item.toLowerCase()]}
                </li>
              ))}
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </section>
);

export default Buttons;



// WEBPACK FOOTER //
// ./source/client/components/detail_nfa/buttons.jsx